// =====================================================================
// «TEGO NO HACE ESTA ACCIÓN SOLO» · AC-12, una sola vez en el código
// =====================================================================
// De los tipos de acción que se pueden poner bajo firma, TEGO ejecuta
// solo los que tienen ejecutor (`backend/app/autorizaciones.py`,
// `EJECUTORES`, y el dato `se_ejecuta_sola`). Los demás se piden, se
// firman y quedan escritos, y la acción la hace una persona a mano.
//
// VIVE AQUÍ Y NO ESCRITO EN CADA PANTALLA (1 oct 2026, EX-5): lo decía
// «Firmas pendientes» antes de firmar, y ahora lo dice también «Reglas de
// autorización» antes de encender. Dos copias de la misma frase acaban
// diciendo dos cosas distintas el día que alguien retoca una; con una sola,
// las dos pantallas dicen lo mismo siempre. Mismo texto y mismas clases que
// tenía `paginas/Autorizaciones.jsx`.
export default function AvisoNoSeEjecutaSola() {
  return (
    <p className="text-xs leading-relaxed text-amber-800 bg-amber-50 border border-amber-200 rounded p-2">
      TEGO no hace esta acción solo. Al autorizarla queda escrito
      quién dio el permiso, y la acción la sigue haciendo una
      persona a mano.
    </p>
  );
}
